import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoadingScreen from './LoadingScreen';

// مكون حماية المسارات للمستخدمين المسجلين
export const ProtectedRoute = () => {
  const { user, loading } = useAuth();

  // عرض شاشة التحميل أثناء التحقق من الجلسة
  if (loading) {
    return <LoadingScreen />;
  }

  // إعادة التوجيه إلى صفحة تسجيل الدخول إذا لم يكن هناك مستخدم مسجل
  if (!user) {
    return <Navigate to="/" replace />;
  }

  // عرض محتوى المسار المحمي
  return <Outlet />;
};

// مكون حماية المسارات للمستخدمين غير المسجلين
export const PublicOnlyRoute = () => {
  const { user, loading } = useAuth();

  // عرض شاشة التحميل أثناء التحقق من الجلسة
  if (loading) {
    return <LoadingScreen />;
  }

  // إعادة التوجيه إلى لوحة التحكم إذا كان المستخدم مسجلاً بالفعل
  // دائماً وجه المستخدمين المسجلين إلى /dashboard
  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  // عرض محتوى المسار العام (مثل صفحة تسجيل الدخول)
  return <Outlet />;
};